import sorted from '../assets/release-2026-10-27/gewerk-01-sortierung.png'
import { makeBox, type GuideStepContent } from './guideStep'

/** Desktop screenshot, 1920×1080. */
const box = makeBox(1920, 1080)

export const HANDWERKER_NACH_GEWERK_INTRO =
  'Beim Planen sortiert der Kalender die Handwerker nach dem Gewerk des Auftrags. So finden Sie schnell den passenden Handwerker.'

export const HANDWERKER_NACH_GEWERK_STEPS: GuideStepContent[] = [
  {
    title: 'Passendes Gewerk zuerst',
    text: 'Sobald Sie einen Termin für einen Auftrag planen, stehen die Handwerker mit dem passenden Gewerk oben. Die übrigen stehen darunter und sind grau. Auch bei ihnen können Sie in die Zeile klicken und den Termin planen.',
    note: {
      title: 'Gewerk kommt aus dem Auftrag',
      text: 'Im Formular wählen Sie das Gewerk nicht mehr aus. Hat der Auftrag kein Gewerk, bleibt die Reihenfolge wie immer und niemand ist grau.',
    },
    image: sorted,
    imageAlt: 'Kalender beim Planen: Tischler oben, die übrigen Handwerker grau darunter',
    focus: [box(332, 316, 1878, 474), box(332, 476, 1878, 916), box(354, 946, 628, 970)],
    wide: true,
  },
]
